import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: index
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/anli',
    name: 'anli',
    component: () => import(/* webpackChunkName: "服务案例" */ '../views/anli.vue')
  },
  {
    path: '/yunying',
    name: 'yunying',
    component: () => import(/* webpackChunkName: "运营团队介绍" */ '../views/yunying.vue')
  },
  {
    path: '/zixun',
    name: 'zixun',
    component: () => import(/* webpackChunkName: "资讯中心" */ '../views/zixun.vue')
  },
  {
    path: '/zixun-details',
    name: 'zixunDetails',
    component: () => import(/* webpackChunkName: "资讯中心" */ '../views/zixun-details.vue')
  },
  // {
  //   path: '/canguan',
  //   name: 'canguan',
  //   component: () => import(/* webpackChunkName: "参观报名" */ '../views/canguan.vue')
  // },
  {
    path: '/lianxi',
    name: 'lianxi',
    component: () => import(/* webpackChunkName: "联系我们" */ '../views/lianxi.vue')
  },
  {
    path: '/guanyu',
    name: 'guanyu',
    component: () => import(/* webpackChunkName: "关于展创云" */ '../views/guanyu.vue')
  },
  {
    path: '/ruanjian',
    name: 'ruanjian',
    component: () => import(/* webpackChunkName: "软件产品" */ '../views/ruanjian.vue')
  },
  {
    path: '/yingjian',
    name: 'yingjian',
    component: () => import(/* webpackChunkName: "硬件产品" */ '../views/yingjian.vue')
  },
  {
    path: '/hujiao',
    name: 'hujiao',
    component:() => import(/* webpackChunkName: "呼叫中心" */ '../views/hujiao.vue')
  },
  {
    path: '/zhengjian',
    name: 'zhengjian',
    component: () => import(/* webpackChunkName: "证件印制制作" */ '../views/zhengjian.vue')
  },
  {
    path: '/shuju',
    name: 'shuju',
    component: () => import(/* webpackChunkName: "数据分析报告" */ '../views/shuju.vue')
  },
  {
    path: '/renyuan',
    name: 'renyuan',
    component: () => import(/* webpackChunkName: "人员服务" */ '../views/renyuan.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
